<template>
  <div class="main-container">
    <div class="main-container-wrapper h">
      <div class="main-footer-left">
        <a
          href="//bszs.conac.cn/sitename?method=show&amp;id=0C1EC20C5B04404AE053012819AC0B79"
          target="_blank"
        >
          <img src="../assets/footer_logo.png" alt="党政机关" />
        </a>
        <a
          style="margin: 0 1em"
          href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=bm72000002&url=http%3A%2F%2Fwww.ncha.gov.cn%2F"
          target="_blank"
        >
          <img src="../assets/zc.png" alt="政府网站|找错" />
        </a>
        <ul>
          <li>
            <span>主办单位：国家文物局</span>
            <span>版权所有：国家文物局</span>
          </li>
          <li>
            <span>运行维护单位: 中国文物信息咨询中心（国家文物局数据中心）</span
            ><span>技术支持电话：010-56792148，010-84849839</span>
          </li>
          <li>
            <span>网站标识码：bm72000002</span>
            <a href="http://beian.miit.gov.cn/" target="_blank"
              >京ICP备13034673号-2</a
            >
            <span
              ><a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102003995"
                target="_blank"
                >京公安网安备 11010102003995 号</a
              ></span
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>

<style scoped lang="less">
@import "../styles/theme";
.h {
  width: 1150px;
}
.main-container {
  background: @dark-theme-color;
  height: @height-footer;
}

.main-footer-left {
  width: 100%;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 12px;

  ul {
    margin-left: 1rem;
    list-style: none;
    padding: 0;

    li {
      line-height: 30px;
    }

    span,
    a {
      margin-right: 24px;
    }
  }
}
</style>
